import ModalElement from './ModalElement';
import SnippetModal from '../Components/SnippetModal';
class SnippetModalElement extends ModalElement {
    constructor() {
        super(...arguments);
        this.element = SnippetModal;
    }
}
export default SnippetModalElement;
